<template>
  <FormulateInput
    label="Jméno"
    type="text"
    name="firstName"
    :value="value"
    :help="help"
    validation="bail|alphaExtendedSpecial|emptyOrMin:2|max:20,length"
    :validation-messages="{
      alphaExtendedSpecial: 'Povolené jsou pouze znaky abecedy',
      emptyOrMin: 'Jméno musí obsahovat minimálně dva znaky',
      max: 'Jméno je omezeno na maximálně 20 znaků',
    }"
    error-behavior="submit"
    :disabled="disabled"
  />
</template>

<script>
export default {
  name: 'FirstNameField',

  props: {
    value: {
      type: String,
    },
    help: {
      type: [String, Boolean],
    },
    disabled: {
      type: Boolean,
    },
  },
};
</script>
